import { render, staticRenderFns } from "./otherList.vue?vue&type=template&id=00772572&scoped=true&"
import script from "./otherList.vue?vue&type=script&lang=js&"
export * from "./otherList.vue?vue&type=script&lang=js&"
import style0 from "./otherList.vue?vue&type=style&index=0&id=00772572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00772572",
  null
  
)

export default component.exports